module.exports = new __parcel__URL__("paw-icon.216b0259.svg").toString();